module.exports = __webpack_public_path__ + "static/media/icon-delete-white.5a3aa421.svg";